import LoggingBase from '../../../../base/loggingbase';
import EventListenerManager from '../../../../utils/EventListenerManager';

/**
 * class MaximizeButtonExtension - creates the maximize/minimize button for an editing
 * control ({@link InputField} / {@link Textarea}). It is a plain delegate: the host is
 * passed in and accessed via {@link #host}. The button's "click" is handled by the host's
 * own {@code onButtonContainerClick}; the mousedown/mouseup (event-swallowing) handlers
 * belong to this extension.
 */
export default class MaximizeButtonExtension extends LoggingBase {

	/**
	 * constructs a new instance
	 * @param {*} host the host editing control (InputField / Textarea)
	 */
	constructor( host ) {
		super( 'widgets.xtw.editing.MaximizeButtonExtension' );
		this._host = host;
	}

	/**
	 * @returns {*} the host editing control
	 */
	get host() {
		return this._host;
	}

	/**
	 * @override
	 */
	doDestroy() {
		this._host = void 0;
		super.doDestroy();
	}

	get newMaximizeButton() {
		return this._getNewExpandBtn( true );
	}

	get newMinimizeButton() {
		return this._getNewExpandBtn( false );
	}

	_getNewExpandBtn( expandIcon = true ) {
		const btnContainer = window.document.createElement( "div" );
		btnContainer.classList.add( "rtp-maximize" );
		const btnIcon = window.document.createElement( "i" );
		// note: the CSS class contains a rotation by 45deg, so we need upright symbols
		btnIcon.classList.add( "fal", ( !!expandIcon ? "fa-long-arrow-up" : "fa-plus" ) );
		btnContainer.appendChild( btnIcon );
		// the "click" is handled by the host's own onButtonContainerClick
		EventListenerManager.addListener( {
			instance: this.host,
			eventName: "click",
			functionName: "onButtonContainerClick",
			callBackPrefix: "ButtonContainer",
			element: btnContainer,
			useCapture: false
		} );
		EventListenerManager.addListener( {
			instance: this,
			eventName: "mousedown",
			functionName: "onButtonContainerMousedown",
			callBackPrefix: "ButtonContainer",
			element: btnContainer,
			useCapture: false
		} );
		EventListenerManager.addListener( {
			instance: this,
			eventName: "mouseup",
			functionName: "onButtonContainerMouseup",
			callBackPrefix: "ButtonContainer",
			element: btnContainer,
			useCapture: false
		} );
		return btnContainer;
	}

	onButtonContainerMousedown( domEvent ) {
		if ( domEvent instanceof MouseEvent ) {
			domEvent.stopPropagation();
			domEvent.preventDefault();
		}
	}

	onButtonContainerMouseup( domEvent ) {
		if ( domEvent instanceof MouseEvent ) {
			domEvent.stopPropagation();
			domEvent.preventDefault();
		}
	}

}
